import { rangePlanningItemsClient } from '../../../app/services/api/rangePlanningItems';

/**
 * Hook that provides Range Planning Items API methods.
 */
const useRangePlanningItemsApi = () => {
  return rangePlanningItemsClient;
};

export default useRangePlanningItemsApi;
